import React, { useState } from 'react';

function JustificativaModal({ isOpen, onClose, onSave }) {
  const [justificativa, setJustificativa] = useState('');

  if (!isOpen) return null;

  const handleSave = () => {
    if (justificativa.trim() === '') {
      alert('Por favor, preencha o motivo.');
      return;
    }
    onSave(justificativa);
    setJustificativa('');
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Motivo do Não Realizado</h2>
        <div className="form-group">
          <label>Por favor, descreva o motivo pelo qual a atividade não foi realizada:</label>
          <textarea
            value={justificativa}
            onChange={(e) => setJustificativa(e.target.value)}
            rows="4"
            required
            autoFocus
          ></textarea>
        </div>
        <div className="modal-actions">
          <button type="button" onClick={onClose} className="btn-cancel">Cancelar</button>
          <button type="button" onClick={handleSave} className="btn-save">Salvar Motivo</button>
        </div>
      </div>
    </div>
  );
}

export default JustificativaModal;